export default __webpack_public_path__ + "static/media/FatualModel.f6849fe3.png";